/**
 * Identity envelopes declare `data` as an array, but several endpoints return a
 * single object for one-item payloads. Read both shapes so a contract drift in
 * `data` cannot break sign-in.
 */
export type ApiEnvelope<T = unknown> = {
  code?: number;
  status?: boolean;
  message?: string;
  timestamp?: string;
  data?: T[] | T | null;
};

export function firstFromEnvelope<T>(data: T[] | T | null | undefined): T | undefined {
  if (data == null) {
    return undefined;
  }
  return Array.isArray(data) ? data[0] : data;
}

export function listFromEnvelope<T>(data: T[] | T | null | undefined): T[] {
  if (data == null) {
    return [];
  }
  return Array.isArray(data) ? data : [data];
}

export function envelopeMessage(body: unknown): string | undefined {
  if (typeof body === 'string' && body.trim()) {
    return body.trim();
  }
  if (!body || typeof body !== 'object') {
    return undefined;
  }
  const message = (body as { message?: unknown }).message;
  return typeof message === 'string' && message.trim() ? message.trim() : undefined;
}

export function envelopeFailed(body: unknown): boolean {
  if (!body || typeof body !== 'object') {
    return false;
  }
  return (body as { status?: unknown }).status === false;
}
